export default "__VITE_ASSET__CvYrq68P__"